import { CfgStage } from '../app/types/catalog-types';
import { useMessages2 } from '../hooks/useLanguage';
import { COMPOSE_STAGE, SUMMARY_STAGE } from '../navigation';
import { stageTextByStageName } from '../util/msg-by-stage-and-tag';
import styles from './configurator-stages.module.css';

export const ConfiguratorStages = ({ className, currentStage, stages, onClick, hasComposeStage, yourConfigDisabled }: {
    className?: string
    currentStage?: string
    stages: CfgStage[]
    onClick: (v:string) => void
    hasComposeStage?: boolean
    yourConfigDisabled: boolean
}) => {

    const { messages } = useMessages2();

    return <ul className={`${className ?? ''} ${styles.stages}`}>
        
        {hasComposeStage && 
            <li key={'compose'} className={(currentStage === COMPOSE_STAGE) ? styles.selected : ''}>
                <button type="button" onClick={() => onClick(COMPOSE_STAGE)}>{ messages?.compose_pagetitle }</button>
            </li>}
        {
        stages.map((stage,i) => {

            const classNames = [];
            if(stage.id === currentStage) {
                classNames.push(styles.selected);
            }
            if(i == stages.length - 1) {
                classNames.push(styles.last);
            }

            return <li key={stage.id} className={classNames.join(' ')}>
                <button type="button" onClick={() => onClick(stage.id)}>{stageTextByStageName(stage.id, messages) ?? stage.name}</button>
            </li>
        })
        }
        <li className={styles.yourConfig}>
            <button type="button" onClick={() => onClick(SUMMARY_STAGE)} disabled={yourConfigDisabled}>{ messages?.offer_pagetitle }</button>
        </li>
    </ul>

};